import { TextStyle } from "pixi.js";
import { GameFont } from "../../common/GameFont";

export class LobbyButtonsTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32,
            fill: '253480',
            align: 'center',
            stroke: 0xffffff,
            strokeThickness: 4,
            lineJoin: "round"
        });
    }
}